const actionKeys = {
  loadAutomation: 'loadAutomation',
  addAutomation: 'addAutomation',
  removeAutomation: 'removeAutomation',
};

const loadAutomations = (allAutomations) => async (dispatch) => {
  dispatch({
    type: actionKeys.loadAutomation,
    payload: {
      allAutomations: allAutomations,
    },
  });
};

const add = (automation) => async (dispatch) => {
  dispatch({
    type: actionKeys.addAutomation,
    payload: {
      automation: automation,
    },
  });
};

const remove = (taskRuleRn) => async (dispatch) => {
  dispatch({
    type: actionKeys.removeAutomation,
    payload: {
      taskRuleRn: taskRuleRn,
    },
  });
};

const defaultState = {
  allAutomations: [],
};

const reducer = (state = defaultState, action) => {
  switch (action.type) {
    case actionKeys.loadAutomation:
      return {
        allAutomations: action.payload.allAutomations,
        lastLoadTime: new Date().toISOString(),
      };
    case actionKeys.addAutomation:
      return {
        ...state,
        allAutomations: [...state.allAutomations, action.payload.automation],
        lastLoadTime: new Date().toISOString(),
      };
    case actionKeys.removeAutomation:
      return {
        ...state,
        allAutomations: state.allAutomations.filter((automation) => automation.taskRuleRn !== action.payload.taskRuleRn),
        lastLoadTime: new Date().toISOString(),
      };
    default:
      return state;
  }
};


export default {
  actions: {
    loadAutomations,
    add,
    remove,
  },
  reducer: reducer,
  defaultState: defaultState,
};
